import { useState, useEffect } from "react";
import ikas from "../../providers/ikas";
import config from "../../config";
import {
  BasketIcon,
  HeartIcon,
  FunnelIcon,
  SortAscendingIcon,
} from "@phosphor-icons/react";
import { useLocation, useNavigate } from "react-router-dom";
import Components from "../index";

const ProductCard = ({
  product,
  onCartIconClick,
  onWishlistIconClick,
  onProductClick,
  isFavorite,
}) => {
  const variant = product.variants?.[0];
  const imageUrl = `https://cdn.myikas.com/images/${config.MERCHANT_ID}/${variant?.images?.[0]?.id}/image_540.webp`;
  const prices = variant?.prices?.[0]; //TODO:priceListId'ye göre seç
  const discount = prices?.discountPrice
    ? "%" +
      Number(
        ((prices?.sellPrice - prices?.discountPrice) / prices?.sellPrice) * 100
      ).toFixed(0) +
      " İNDİRİM"
    : "";
  const selectedTotalStock = variant?.stocks?.reduce(
    (totalValue, currentValue) => {
      return totalValue + currentValue.stockCount;
    },
    0
  );
  const isAvailable = selectedTotalStock > 0 || variant?.availableForSale;

  return (
    <div
      onClick={onProductClick}
      key={product.id}
      className={`flex flex-col bg-white rounded-md shadow min-w-0 w-full border border-gray-200 relative ${
        isAvailable ? "" : "opacity-50"
      }`}
    >
      <div className="absolute top-2 right-2 left-2 flex justify-between z-10">
        <button
          className="text-gray-400 hover:text-gray-600 bg-white/80 rounded-full p-1"
          onClick={(e) => {
            e.stopPropagation();
            onCartIconClick();
          }}
        >
          <BasketIcon color="#000" />
        </button>
        <button
          className="text-gray-400 hover:text-red-500 bg-white rounded-full p-1"
          onClick={(e) => {
            e.stopPropagation();
            onWishlistIconClick();
          }}
        >
          <HeartIcon
            color={isFavorite ? "#f00" : "#000"}
            weight={isFavorite ? "fill" : "regular"}
          />
        </button>
      </div>
      <img
        src={imageUrl}
        alt={product.name}
        className="w-full h-[200px] object-cover mb-2 bg-gray-50 rounded-t-md"
        draggable={false}
      />
      <div className="flex flex-col px-2 pb-2">
        <div
          style={{ fontWeight: "500", color: "#404040", fontSize: "11px" }}
          className="font-medium text-sm mb-3 line-clamp-2 min-h-[38px]"
        >
          {product.name}
        </div>
        <div className="flex flex-col ">
          {prices?.discountPrice && (
            <span
              style={{ color: "#adadad", fontSize: "10px" }}
              className="text-xs text-gray-400 line-through"
            >
              ₺
              {parseFloat(prices?.sellPrice).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          )}
          <span
            style={{ color: "#000", fontSize: "12px" }}
            className="font-bold text-base text-gray-900"
          >
            ₺
            {parseFloat(
              prices?.discountPrice ?? prices?.sellPrice
            ).toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
      </div>
      {discount && (
        <div
          style={{ backgroundColor: "#292929", fontWeight: "900" }}
          className="bg-black text-white text-xs font-bold rounded-b px-2 py-1 text-center w-full"
        >
          {discount}
        </div>
      )}
    </div>
  );
};

const Category = ({ data, dataSetter }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [page, setPage] = useState(1);

  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [currentFilters, setCurrentFilters] = useState([]);
  const [currentSortType, setCurrentSortType] = useState("CREATED_AT_DESC");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showSortModal, setShowSortModal] = useState(false);
  const [facets, setFacets] = useState([]);
  const [productFilterData, setProductFilterData] = useState();

  const [quickBuyProduct, setQuickBuyProduct] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [quickBuyVisible, setQuickBuyVisible] = useState(false);
  const [quickBuyModalVisible, setQuickBuyModalVisible] = useState(false);
  const [quickBuyLoading, setQuickBuyLoading] = useState(false);
  const [quickBuyToast, setQuickBuyToast] = useState("");
  const [showQuickBuyToast, setShowQuickBuyToast] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [cartModalVisible, setCartModalVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { id } = location.state;

  const convertSortTypeToOrder = (sortType) => {
    switch (sortType) {
      case "CREATED_AT_DESC":
        return [{ direction: "DESC", type: "CREATED_AT" }];
      case "CREATED_AT_ASC":
        return [{ direction: "ASC", type: "CREATED_AT" }];
      case "PRICE_ASC":
        return [{ direction: "ASC", type: "PRICE" }];
      case "PRICE_DESC":
        return [{ direction: "DESC", type: "PRICE" }];
      case "NAME":
        return [{ direction: "ASC", type: "NAME" }];
      case "SALE_COUNT":
        return [{ direction: "DESC", type: "SALE_COUNT" }];
      case "REVIEW_COUNT":
        return [{ direction: "DESC", type: "REVIEW_COUNT" }];
      case "AVERAGE_RATING":
        return [{ direction: "DESC", type: "AVERAGE_RATING" }];
      default:
        return [{ direction: "DESC", type: "CREATED_AT" }];
    }
  };

  const onCartIconClick = (product) => {
    let productVariantsHashMap = {};
    product.variants.forEach((variant) => {
      let key = "";
      variant.variantValues.forEach((vv) => {
        key += vv.variantTypeId + vv.variantValueId + "/";
      });
      if (key.endsWith("/")) key = key.slice(0, -1);
      productVariantsHashMap[key] = { ...variant, key };
    });
    const firstVariantKey = Object.keys(productVariantsHashMap)[0];
    const firstVariant = productVariantsHashMap[firstVariantKey];
    setSelectedVariant(firstVariant);
    setQuickBuyProduct({ ...product, variantMap: productVariantsHashMap });

    setQuickBuyVisible(true);
    setTimeout(() => setQuickBuyModalVisible(true), 10);
  };

  const onWishlistIconClick = (product) => {
    let newFavorites = [...data.favorites];
    if (data?.favorites?.includes(product.id)) {
      newFavorites = data.favorites.filter((id) => id !== product.id);
    } else {
      newFavorites.push(product.id);
    }
    dataSetter({
      key: "favorites",
      value: newFavorites,
    });
    localStorage.setItem("favorites", JSON.stringify(newFavorites));
  };
  const onProductClick = (product) => {
    navigate(`/product`, {
      state: product,
    });
  };

  const fetchProducts = async (
    isLoadMore = false,
    filters = currentFilters,
    sortType = currentSortType
  ) => {
    if (loading || loadingMore) return;
    if (!id) return;
    if (isLoadMore && !hasNextPage) return;

    if (isLoadMore) {
      setLoadingMore(true);
    } else {
      setLoading(true);
      setPage(1);
      setProducts([]);
    }

    try {
      let filterData = productFilterData;

      if (!filterData) {
        const res = await ikas.getProductFilterData();
        setProductFilterData(res);
        filterData = res;
      }
      filterData = filterData.filters.map(({ id, type, displayType }) => {
        return {
          id,
          type,
          displayType,
        };
      });

      const input = {
        categoryIdList: [id],
        page: isLoadMore ? page + 1 : 1,
        perPage: 20,
        order: convertSortTypeToOrder(sortType),
        filterList: filters,
        facetList: filterData,
        showStockOption: "SHOW_OUT_OF_STOCK_AT_END",
      };

      const response = await ikas.searchProducts(input);
      const result = response.results;

      if (response.page === 1) {
        setFacets(response.facets);
      }

      if (isLoadMore) {
        setProducts((prev) => [...prev, ...result]);
      } else {
        setProducts(result);
      }

      setPage((prev) => (isLoadMore ? prev + 1 : 1));
      setHasNextPage(response.totalCount > (isLoadMore ? page + 1 : 1) * 20);
    } catch (err) {
      console.error(err);
      setProducts([]);
      setHasNextPage(false);
    } finally {
      if (isLoadMore) {
        setLoadingMore(false);
      } else {
        setLoading(false);
      }
      setFetchCompleted(true);
    }
  };

  const handleFilterSave = (filters) => {
    setCurrentFilters(filters);
    fetchProducts(false, filters, currentSortType);
  };

  const handleFilterCancel = () => {
    setCurrentFilters([]);
    handleFilterSave([]);
  };

  const handleSortSave = (sortType) => {
    setCurrentSortType(sortType);
    fetchProducts(false, currentFilters, sortType);
  };

  const handleSortCancel = () => {
    handleSortSave("CREATED_AT_DESC");
  };

  useEffect(() => {
    fetchProducts(false);
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100 &&
        hasNextPage &&
        !loading &&
        !loadingMore
      ) {
        fetchProducts(true, currentFilters, currentSortType);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [
    hasNextPage,
    loading,
    loadingMore,
    page,
    id,
    currentFilters,
    currentSortType,
  ]);

  return (
    <div className="pb-20">
      {/* Filter and Sort Buttons */}
      {fetchCompleted && (
        <div className="flex gap-3 px-2 py-4 max-w-xl mx-auto">
          {productFilterData?.filters?.length > 0 && (
            <button
              onClick={() => setShowFilterModal(true)}
              className="flex-1 flex items-center justify-center gap-2 bg-white border border-gray-300 rounded-lg py-3 px-4 shadow-sm hover:border-gray-400 transition-colors"
            >
              <FunnelIcon size={16} />
              <span className="text-sm font-medium">Filtrele</span>
              {currentFilters.length > 0 && (
                <span className="bg-black text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                  {currentFilters.length}
                </span>
              )}
            </button>
          )}
          <button
            onClick={() => setShowSortModal(true)}
            className={`${
              productFilterData?.filters?.length > 0 ? "flex-1" : "w-full"
            } flex items-center justify-center gap-2 bg-white border border-gray-300 rounded-lg py-3 px-4 shadow-sm hover:border-gray-400 transition-colors`}
          >
            <SortAscendingIcon size={16} />
            <span className="text-sm font-medium">Sırala</span>
          </button>
        </div>
      )}
      {loading && (
        <div className="grid grid-cols-2 gap-3 pb-2 px-2 max-w-xl mx-auto mt-4">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="flex flex-col bg-white rounded-lg shadow p-2 min-w-0 w-full border border-gray-200 animate-pulse"
            >
              <div className="flex justify-between mb-1">
                <div className="w-6 h-6 bg-gray-200 rounded-full" />
                <div className="w-6 h-6 bg-gray-200 rounded-full" />
              </div>
              <div className="w-full h-32 bg-gray-200 mb-2 rounded" />
              <div className="h-4 bg-gray-200 rounded mb-3 w-5/6" />
              <div className="flex flex-col mb-1 gap-1">
                <div className="h-4 bg-gray-200 rounded w-1/2" />
                <div className="h-4 bg-gray-200 rounded w-2/3" />
              </div>
              <div className="h-5 bg-gray-200 rounded w-1/2 mx-auto mt-2" />
            </div>
          ))}
        </div>
      )}
      {!loading && products.length > 0 && (
        <div className="grid grid-cols-2 gap-3 pb-2 px-2 max-w-xl mx-auto mt-4">
          {products.map((product) => {
            const isFavorite = data.favorites.includes(product.id);
            return (
              <ProductCard
                key={product.id}
                product={product}
                isFavorite={isFavorite}
                onCartIconClick={() => onCartIconClick(product)}
                onWishlistIconClick={() => onWishlistIconClick(product)}
                onProductClick={() => onProductClick(product)}
              />
            );
          })}
          {loadingMore &&
            [...Array(2)].map((_, i) => (
              <div
                key={"loading-more-" + i}
                className="flex flex-col bg-white rounded-lg shadow p-2 min-w-0 w-full border border-gray-200 animate-pulse"
              >
                <div className="flex justify-between mb-1">
                  <div className="w-6 h-6 bg-gray-200 rounded-full" />
                  <div className="w-6 h-6 bg-gray-200 rounded-full" />
                </div>
                <div className="w-full h-32 bg-gray-200 mb-2 rounded" />
                <div className="h-4 bg-gray-200 rounded mb-3 w-5/6" />
                <div className="flex flex-col mb-1 gap-1">
                  <div className="h-4 bg-gray-200 rounded w-1/2" />
                  <div className="h-4 bg-gray-200 rounded w-2/3" />
                </div>
                <div className="h-5 bg-gray-200 rounded w-1/2 mx-auto mt-2" />
              </div>
            ))}
        </div>
      )}
      {!loading && fetchCompleted && products.length === 0 && (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
            <circle cx="32" cy="32" r="30" stroke="#e4e4e4" strokeWidth="4" />
            <path
              d="M44 44L54 54"
              stroke="#bdbdbd"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <circle cx="30" cy="30" r="12" stroke="#bdbdbd" strokeWidth="3" />
          </svg>
          <div className="mt-4 text-lg font-semibold text-gray-700">
            Ürün bulunamadı
          </div>
          <div className="text-sm text-gray-400 mt-1">
            Bu kategoride ürün bulunamadı.
            <br />
            Farklı bir kategori seçebilirsiniz.
          </div>
        </div>
      )}
      {loadingMore && (
        <div className="flex justify-center items-center py-4">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-black rounded-full animate-spin" />
        </div>
      )}

      {/* Quick Buy Modal */}
      {quickBuyVisible && quickBuyProduct && (
        <div
          className="fixed inset-0 z-[200] flex flex-col justify-end bg-black bg-opacity-40"
          onClick={() => {
            setQuickBuyModalVisible(false);
            setTimeout(() => setQuickBuyVisible(false), 300);
          }}
        >
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6  relative transition-all duration-300 ${
              quickBuyModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
            }`}
            style={{ minHeight: 200 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-3 right-3 flex gap-2">
              <button
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
                onClick={() => {
                  setQuickBuyModalVisible(false);
                  setTimeout(() => setQuickBuyVisible(false), 300);
                }}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>

            <div className="flex items-center px-6 pt-1 pb-4">
              <div>
                <div className="font-bold text-lg">{quickBuyProduct.name}</div>
                {selectedVariant?.selectedOptions?.map((option) => (
                  <div key={option.name} className="text-sm text-gray-700">
                    {option.name}: {option.value}
                  </div>
                ))}
              </div>
            </div>

            {/* Options selector */}
            <div className="px-6 pb-4">
              {quickBuyProduct.productVariantTypes?.map(
                ({ variantType }, index) => {
                  return (
                    variantType.values.length > 1 && (
                      <div key={index} className="mb-4">
                        <div className="grid grid-cols-4 gap-3">
                          {variantType.values.map((value) => {
                            const splittedSelectedVariantKey =
                              selectedVariant.key.split("/");
                            splittedSelectedVariantKey[index] =
                              variantType.id + value.id;
                            let key = splittedSelectedVariantKey.join("/");

                            const variant = quickBuyProduct.variantMap[key];
                            const variantStock = variant?.stocks?.reduce(
                              (totalValue, currentValue) => {
                                return totalValue + currentValue.stockCount;
                              },
                              0
                            );
                            const isSelected = selectedVariant.key === key;
                            const isAvailable =
                              variantStock > 0 || variant?.availableForSale;

                            return (
                              <button
                                key={value.id}
                                onClick={() => {
                                  setSelectedVariant(variant);
                                }}
                                disabled={!isAvailable}
                                className={`h-12 rounded text-sm font-medium transition-colors duration-200 ${
                                  isSelected
                                    ? "bg-black text-white"
                                    : "bg-gray-100 text-black hover:bg-gray-200"
                                } ${
                                  !isAvailable
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                              >
                                {value.name}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )
                  );
                }
              )}
            </div>

            {/* Add to Cart Button */}
            <div className="px-6 pb-2">
              <button
                className="w-full bg-black text-white py-3 rounded-sm text-base font-bold"
                disabled={quickBuyLoading}
                onClick={async () => {
                  const cartId =
                    localStorage.getItem("cartId") ??
                    sessionStorage.getItem("cartId");
                  setQuickBuyLoading(true);
                  try {
                    const input = {
                      cartId,
                      salesChannelId: config.SALES_CHANNEL_ID,
                      storefrontThemeId: config.ROUTING_ID,
                      item: {
                        quantity: 1,
                        variant: {
                          id: selectedVariant.id,
                          name: quickBuyProduct.name,
                        },
                      },
                    };

                    const addResult = await ikas.addItemToCart(input);
                    console.log(addResult);
                    dataSetter(addResult);
                    setShowCartModal(true);
                    setTimeout(() => setCartModalVisible(true), 10);
                    setQuickBuyModalVisible(false);
                    setTimeout(() => setQuickBuyVisible(false), 300);
                  } catch (err) {
                    console.error(err);
                    setQuickBuyToast("Bir hata oluştu");
                    setShowQuickBuyToast(true);
                    setTimeout(() => setShowQuickBuyToast(false), 1500);
                  } finally {
                    setQuickBuyLoading(false);
                  }
                }}
              >
                Add to cart
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading overlay for QuickBuy */}
      {quickBuyLoading && (
        <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black bg-opacity-60">
          <span className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
        </div>
      )}

      {/* Toast for QuickBuy */}
      {quickBuyToast && (
        <div
          className={`fixed left-1/2 transform -translate-x-1/2 z-[210] w-[95vw] max-w-xl bg-black text-white px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400 ${
            showQuickBuyToast
              ? "opacity-100 translate-y-0"
              : "opacity-0 -translate-y-4 pointer-events-none"
          }`}
          style={{ minWidth: 320, top: 20 }}
        >
          {quickBuyToast}
        </div>
      )}

      {/* Cart confirmation modal */}
      {showCartModal && selectedVariant && quickBuyProduct && (
        <div className="fixed inset-0 z-[300] flex flex-col justify-end bg-black bg-opacity-40">
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6 px-4 flex flex-row items-center relative transition-all duration-300 ${
              cartModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
            }`}
            style={{ minHeight: 160 }}
          >
            <button
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
              onClick={() => {
                setCartModalVisible(false);
                setTimeout(() => setShowCartModal(false), 300);
              }}
              aria-label="Kapat"
            >
              ×
            </button>
            <img
              src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${selectedVariant?.images?.[0]?.id}/image_540.webp`}
              alt={quickBuyProduct.name}
              className="w-20 h-20 object-contain rounded mr-4 flex-shrink-0"
            />
            <div className="flex flex-col flex-1 items-start">
              <div className="text-green-600 font-bold text-lg mb-1">
                Product Added
              </div>
              <div className="font-semibold text-sm mb-3">
                {quickBuyProduct.name}
                {selectedVariant.name && selectedVariant.name !== "Default" && (
                  <>
                    :{" "}
                    <span className="font-normal">{selectedVariant.name}</span>
                  </>
                )}
              </div>
              <button
                className="w-full bg-black text-white py-2 rounded-lg font-bold mb-2"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                  navigate("/cart");
                }}
              >
                Go to cart
              </button>
              <button
                className="w-full bg-gray-100 text-black py-2 rounded-lg font-semibold"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                }}
              >
                Continue shopping
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Filter Modal */}
      <Components.FilterModal
        isVisible={showFilterModal}
        onClose={() => setShowFilterModal(false)}
        onSave={handleFilterSave}
        onCancel={handleFilterCancel}
        productFilterData={productFilterData}
        facets={facets}
        currentFilters={currentFilters}
      />

      {/* Sort Modal */}
      <Components.SortModal
        isVisible={showSortModal}
        onClose={() => setShowSortModal(false)}
        onSave={handleSortSave}
        onCancel={handleSortCancel}
        currentSortType={currentSortType}
        productFilterData={productFilterData}
      />
    </div>
  );
};

export default Category;
